import type { ReactNode } from "react";

type BlockProps = {
  children: ReactNode;
};

type TimelineItem = {
  date: string;
  title: string;
  description: string;
};

type TimelineProps = {
  items?: TimelineItem[];
  children?: ReactNode;
};

export function ShortAnswer({ children }: BlockProps) {
  return <div className="short-answer">{children}</div>;
}

export function FactList({ children }: BlockProps) {
  return <div className="fact-list">{children}</div>;
}

export function RelatedTerms({ children }: BlockProps) {
  return <div className="related-terms">{children}</div>;
}

export function FAQ({ children }: BlockProps) {
  return <div className="faq-list">{children}</div>;
}

export function ReferenceList({ children }: BlockProps) {
  return <div className="reference-list">{children}</div>;
}

export function Timeline({ items = [], children }: TimelineProps) {
  if (items.length === 0) {
    return <div className="timeline">{children}</div>;
  }

  return (
    <ol className="timeline" aria-label="Timeline">
      {items.map((item) => (
        <li key={`${item.date}-${item.title}`} className="timeline__item">
          <time>{item.date}</time>
          <div>
            <strong>{item.title}</strong>
            <p>{item.description}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
